module.exports = __webpack_public_path__ + "img/folder-upload.30010900.svg";